module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/ir-04baefbc72bea0cb32f5a1de16e0da42.svg";